/**
 * localStorage 래퍼 (npm 패키지 'store' 대체)
 * - 자동 JSON 직렬화/역직렬화
 * - 현대 브라우저 전용 (localStorage 네이티브 사용)
 */

export function getItem<T = any>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key)
    if (raw === null) return null
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export function setItem(key: string, value: any): void {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // localStorage full or unavailable
  }
}

export function removeItem(key: string): void {
  localStorage.removeItem(key)
}
